import React, { Fragment } from "react"
import "./PinnedUsers.scss"
import { selectIcon, SVG } from "../../../../components/UI/selector"

export default function PinnedUsers({ allUsers, userPin, tagUsers }) {
  const users = tagUsers
    .filter((el) => el.showStream)
    .map((data) => {
      const el = { ...allUsers[data.user_id] }
      return <PinnedUser key={el.user_id} user={el} userPin={userPin} />
    })
  const noState = (
    <Fragment>
      <div className={"pin-icon"}>
        <SVG
          src={selectIcon("pinIcon")}
          height={10}
          width={10}
          fill="#767676"
        />
      </div>
      <div>Pin your friends to see them during the workout</div>
    </Fragment>
  )
  return <div className={"PinnedUsers"}>{users.length ? users : noState}</div>
}

function PinnedUser({ user, userPin }) {
  return (
    <div className={"PinnedUser"}>
      <img src={user.profile_pic_thumb} height={33} width={33} />
      <span className={"userName"}>{user.first_name}</span>
      <div
        className={"pin-icon"}
        onClick={() => {
          userPin(user.user_id)
        }}
      >
        <SVG
          src={selectIcon("pinIcon")}
          height={10}
          width={10}
          fill="var(--color-primary)"
        />
      </div>
    </div>
  )
}
